import { Vue, Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { dropMenuProject } from '@/types/dropMenu';
import { getHomeSingleRank } from '@/apis/index';
import { tableHeaderProject } from '@/types/tableHeader';
import { pushBy2804 } from '@/utils/tools';
import { singleRankHead, STAT, AJAX_STATUS } from '@/config/config';

@Component
export class RankCommon extends Vue {
  @Prop() public maxLength!: number;
  list = [];
  // 接口请求状态
  ajaxStatus = AJAX_STATUS.loading;
  domIndex = 0;
  isLoading = false;
  isHandleScroll = false;
  refName = '';
  handleData(flag: boolean, list: Array<any>, cb, type) {
    const { nomore, end, nodata } = AJAX_STATUS;
    if (flag) {
      this.list = list;
    } else {
      this.list = this.list.concat(list);
      this.$nextTick(() => {
        !this.maxLength && !this.isHandleScroll && this.handleScroll(cb, type);
      });
    }
    if (!list.length) {
      this.ajaxStatus = this.list.length ? nomore : nodata;
    } else {
      this.ajaxStatus = list.length < 15 ? nomore : end;
    }
    this.isLoading = false;
  }
  handleScroll(cb, type) {
    let dom = null;
    let list = null;
    if (type === 'home') {
      dom = window.$('.rank-single-list')[this.domIndex] as HTMLElement;
      list = this.$refs[this.refName] as HTMLElement;
    } else {
      dom = this.$refs[this.refName] as HTMLElement;
      list = this.$refs[`${this.refName}list`] as HTMLElement;
    }
    this.isHandleScroll = true;
    dom.addEventListener('scroll', () => {
      const { clientHeight } = dom;
      const listHeight = list.scrollHeight;
      if (dom.scrollTop + clientHeight >= listHeight - 3) {
        cb(false);
      }
    });
  }
  unableAjax(flag: boolean) {
    const { nomore, loading } = AJAX_STATUS;
    if (flag) {
      this.list = [];
    } else {
      if (this.isLoading || this.ajaxStatus === nomore) {
        return true;
      }
    }
    this.isLoading = true;
    this.ajaxStatus = loading;
    return false;
  }
}

@Component
export class SingleRankMixin extends Mixins(RankCommon) {
  // 选择的周期
  @Prop() private selectedDate!: string;
  // 排行类型
  @Prop() private activeStatus!: boolean;
  @Prop() private rankType!: string;
  @Prop() private api!: any;
  // 激活的时候去请求接口
  @Watch('activeStatus', { immediate: true })
  onActiveStatusChanged(newValue: boolean) {
    if (newValue) {
      // 激活获取数据
      this.getData(false);
    }
  }
  // 监听选择周期的变化去更新数据
  @Watch('selectedDate')
  onSelectedDateChanged() {
    this.getData(true);
  }
  // 监听排序类型
  @Watch('rankType')
  onRankTypeChanged() {
    this.getData(true);
  }
  toSingle(info: any) {
    const stat = this.$route.name === 'rank' ? STAT.rank : STAT.homeRecommend;
    window.hxmClickStat(`${stat}.gegu`);
    // 跳转路由 个股主页
    pushBy2804('/stockPage', {
      stockcode: info.stockCode,
      stockname: info.stockName,
      name: info.stockName,
      marketid: info.market,
    });
  }
  reloadData() {
    this.getData(true);
  }
  getData(flag: boolean = false) {
    // 获取数据
    if (this.unableAjax(flag)) {
      return;
    }
    const ajaxObj: any = {
      type: this.selectedDate,
      start: flag ? 0 : this.list.length,
      limit: 15,
    };
    if (this.rankType) {
      ajaxObj.order_by = this.rankType;
    }
    const { end, nodata } = AJAX_STATUS;
    this.api(ajaxObj)
      .then(res => {
        if (res.statusCode === 0) {
          const list = res.data.list.slice(0, this.maxLength || 15);
          this.handleData(flag, list, this.getData, 'home');
        } else {
          this.ajaxStatus = this.list.length ? end : nodata;
        }
      })
      .catch(() => {
        this.ajaxStatus = end;
      });
  }
}

@Component
export class RankMixin extends Mixins(RankCommon) {
  // 是否限制数组长度
  dropMenu = null;
  // 展示的数组
  rankType = '0';
  // 当前排序的索引
  sortIndex = 1;
  // 获取表头
  tableHead = null;
  api = null;
  selectDate = '';
  defaultDate = '';
  followType = '';
  followId = '';
  // 数据同步
  listInfo = {
    authorId: '$followAuthorList',
    orgId: '$followOrgList',
    industryId: '$followIndustryList',
  };
  reloadData() {
    this.getData(true);
  }
  sortList(index) {
    // 交互确认 对当前的表单进行排序
    const item = this.tableHead[index];
    const status = item.rankStatus;
    if (status) {
      // 已经在排序状态
      return;
    }
    if (typeof status === 'number') {
      // 切换排序的状态
      const newStatus = status === 1 ? 0 : status + 1;
      this.$set(this.tableHead[index], 'rankStatus', newStatus);
      this.$set(this.tableHead[this.sortIndex], 'rankStatus', 0);
      // 排序类型
      this.rankType = item?.rankType;
      this.getData(true);
      this.sortIndex = index;
    }
  }
  changeInfo(info: dropMenuProject) {
    this.selectDate = info.value;
    this.getData(true);
    this.$emit('jumpIndex', info);
  }
  followIndustry(info: any, index) {
    const pageStat = this.$route.name === 'rank' ? STAT.rank : `${STAT.homeRecommend}.hy`;
    const status = this.list[index].isFollow;
    const stat = status ? 'offguanzhu' : 'guanzhu';
    window.hxmClickStat(`${pageStat}.${stat}`);
    getHomeSingleRank({
      con: 'user',
      act: 'follow',
      type: this.followType,
      followId: info[this.followId],
      status: status ? -1 : 1,
    }).then(res => {
      if (res.statusCode === 0) {
        this.$set(this.list[index], 'isFollow', !status);
        this.$set(this[this.listInfo[this.followId]], info[this.followId], status ? 1 : 2);
      }
    });
  }
  getData(flag: boolean = false) {
    // 获取数据
    if (this.unableAjax(flag)) {
      return;
    }
    const { end } = AJAX_STATUS;
    this.api({
      type: this.selectDate,
      order_by: this.rankType,
      start: flag ? 0 : this.list.length,
      limit: 15,
    })
      .then(res => {
        if (res.statusCode === 0) {
          const len = this.maxLength || 15;
          const list = res.data.list.slice(0, len);
          list.forEach(element => {
            this.$set(this[this.listInfo[this.followId]], element[this.followId], element.isFollow ? 2 : 1);
          });
          this.handleData(flag, list, this.getData, 'rank');
        } else {
          this.ajaxStatus = end;
        }
      })
      .catch(() => {
        this.ajaxStatus = end;
      });
  }
  mounted() {
    this.getData();
  }
}

@Component
export class SingleRankTab extends Vue {
  singleRankHead: tableHeaderProject[][] = singleRankHead;
  activeIndex = 0;
  rankType = '0';
  sortIndex = 1;
  sortList(index) {
    // 交互确认 对当前的表单进行排序
    const item = this.singleRankHead[this.activeIndex][index];
    const status = item.rankStatus;
    if (status) {
      // 已经在排序状态
      return;
    }
    if (typeof status === 'number') {
      // 切换排序的状态
      const newStatus = status === 1 ? 0 : status + 1;
      this.$set(this.singleRankHead[this.activeIndex][index], 'rankStatus', newStatus);
      this.$set(this.singleRankHead[this.activeIndex][this.sortIndex], 'rankStatus', 0);
      // 排序类型
      this.rankType = item?.rankType;
      this.sortIndex = index;
    }
  }
}
